export default function AddMinutesToDate(date: Date | null, minutes: number): Date | null {
    if (date != null) {
      return new Date(date.getTime() + minutes * 60000);
    }
    return null
  }